import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body pb-0" }
const _hoisted_2 = { class: "d-flex align-items-center mb-5" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1\"><div class=\"symbol symbol-45px me-5\"><img src=\"media/avatars/300-23.jpg\" alt=\"\"></div><div class=\"d-flex flex-column\"><a href=\"#\" class=\"text-gray-800 text-hover-primary fs-6 fw-bolder\">Nick Logan</a><span class=\"text-gray-400 fw-bold\">PHP, SQLite, Artisan CLI</span></div></div>", 1)
const _hoisted_4 = { class: "my-0" }
const _hoisted_5 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-800 fw-normal mb-5" }, " Outlines keep you honest. They stop you from indulging in poorly thought-out metaphors about driving and keep you focused on the overall structure of your post ", -1)
const _hoisted_9 = { class: "d-flex align-items-center mb-5" }
const _hoisted_10 = {
  href: "#",
  class: "btn btn-sm btn-light btn-color-muted btn-active-light-success px-4 py-2 me-4"
}
const _hoisted_11 = { class: "svg-icon svg-icon-3" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 120 ")
const _hoisted_13 = {
  href: "#",
  class: "btn btn-sm btn-light btn-color-muted btn-active-light-danger px-4 py-2"
}
const _hoisted_14 = { class: "svg-icon svg-icon-3" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 15 ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-4" }, null, -1)
const _hoisted_17 = { class: "position-relative mb-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("textarea", {
  class: "form-control border-0 p-0 pe-10 resize-none min-h-25px",
  "data-kt-autosize": "true",
  rows: "1",
  placeholder: "Reply.."
}, null, -1)
const _hoisted_19 = { class: "position-absolute top-0 end-0 me-n5" }
const _hoisted_20 = { class: "btn btn-icon btn-sm btn-active-color-primary pe-0 me-2" }
const _hoisted_21 = { class: "svg-icon svg-icon-3 mb-3" }
const _hoisted_22 = { class: "btn btn-icon btn-sm btn-active-color-primary ps-0" }
const _hoisted_23 = { class: "svg-icon svg-icon-2 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown2 = _resolveComponent("Dropdown2")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
            ])
          ]),
          _createVNode(_component_Dropdown2)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com012.svg" })
            ]),
            _hoisted_12
          ]),
          _createElementVNode("a", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen030.svg" })
            ]),
            _hoisted_15
          ])
        ])
      ]),
      _hoisted_16,
      _createElementVNode("form", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com008.svg" })
            ])
          ]),
          _createElementVNode("span", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
            ])
          ])
        ])
      ])
    ])
  ], 2))
}